module.exports = __webpack_public_path__ + "img/4.c595a950.svg";